import { render } from "./ShipmentHeader.vue?vue&type=template&id=057c06b9"
import script from "./ShipmentHeader.vue?vue&type=script&lang=js"
export * from "./ShipmentHeader.vue?vue&type=script&lang=js"

import "./ShipmentHeader.vue?vue&type=style&index=0&id=057c06b9&lang=css"

import exportComponent from "/Users/macmini/Sites/self-ship/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__